module.exports = __webpack_public_path__ + "static/media/mastercard.5fb7cae4.svg";